import { VTextField } from 'vuetify/lib/components/index.mjs';

export const textfieldDefaults: Partial<VTextField> = {
  variant: 'solo',
  flat: true,
  singleLine: true,
};
